import {ShipmentActionCd} from '../';
import {EnumHelper} from './enum-helper';

export class ShipmentActionCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in ShipmentActionCd ) {
      this._values.push(ShipmentActionCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): ShipmentActionCd {

    for ( const obj in ShipmentActionCd ) {
      if (ShipmentActionCd[obj] === value){
        return ShipmentActionCd[obj] as ShipmentActionCd;
      }
    }
  }
}

const ShipmentActionCdHelper = new ShipmentActionCdHelperEnumHelperClass();
export default ShipmentActionCdHelper;
